var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zoho-widget" },
    [
      _c(
        "div",
        { staticClass: "widget-header" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.zohoCRM")))]),
          _vm._v(" "),
          !_vm.hasZohoChannel
            ? _c(
                "SupsisButton",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.connectToZoho },
                },
                [_vm._v(_vm._s(_vm.$t("message.connectToZoho")))]
              )
            : _c(
                "SupsisButton",
                {
                  attrs: { icon: "open_in_new", ghost: "" },
                  on: { click: _vm.gotoContactOnZoho },
                },
                [_vm._v(_vm._s(_vm.$t("message.viewContact")))]
              ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasZohoChannel
        ? _c("a-alert", {
            attrs: { message: "Connected to Zoho", type: "success" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("ZohoContactsSection", { attrs: { contact: _vm.contact } }),
      _vm._v(" "),
      _c("ZohoDealsSection", {
        attrs: { contact: _vm.contact },
        on: { "connect-zoho": _vm.connectToZoho },
      }),
      _vm._v(" "),
      _c("ZohoLeadsSection", { attrs: { contact: _vm.contact } }),
      _vm._v(" "),
      _c("ZohoSalesOrdersSection", { attrs: { contact: _vm.contact } }),
      _vm._v(" "),
      _vm.postOperationSectionEnabled
        ? _c("ZohoPostOperationsSection", { attrs: { contact: _vm.contact } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }